import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import AccessPicker from '../../_shared/AccessPicker'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const AccessSection = () => {
  const { t } = useTranslation('editFormV2')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('accessSectionTitle')}
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%">
          <FormItem field="access" Input={AccessPicker} />
        </Col>
      </Grid>
    </>
  )
}

export default AccessSection
